import Tablets from "./Tablets";

export * from "./Ambulance";
export * from "./Bandage";
export * from "./Brain";
export * from "./BriefcaseMedical";
export * from "./Cigarette";
export * from "./CigaretteOff";
export * from "./ClipboardMinus";
export * from "./ClipboardPlus";
export * from "./Dna";
export * from "./HeartPulse";
export * from "./Microscope";
export * from "./Pill";
export * from "./PillBottle";
export * from "./Siren";
export * from "./Stethoscope";
export * from "./Syringe";
export * from "./Tablets";

export const Medival = {
  Tablets,
};
